import Image from '../../components/Image/Image';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Block from '../../adapters/helpers/Block';
import { AwardsBlockConstant } from '../../adapters/helpers/Constants'

class AwardsBlock extends Component {
    constructor(props) {
        super(props);
        this.block = new Block(props);
    
        this.classNames = 'ob-awards-block';
        if (this.block.getFieldValue('classNames')) {
            this.classNames += ' ' + this.block.getFieldValue('classNames');
        }
        this.anchorId = this.block.getAnchorId();
        this.awards = this.block.getFieldValue('awards');
    }
    
    renderAward(block, index) {
        const awardBlock = new Block(block);
    
        return (
            <div key={index} className={'ob-awards-block__award-item'}>
                <div key={index} className={'ob-awards-block__award-item-content'}>
                    <div className={'ob-awards-block__award-item-logo'}>
                    <a href={awardBlock.getFieldValue('ctaLink')} rel='noopener noreferrer' className={'ob-awards-block__award-item-link'} target={'_blank'} aria-label={`${AwardsBlockConstant.awardItemLogo}-${awardBlock.getFieldValue('title')}`}>
                            <Image image={awardBlock.getFieldValue('logo')} />
                            <div className={'ob-awards-block__award-item-title'}>
                            {awardBlock.getFieldValue('title')}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div id={this.anchorId} className={this.classNames}>
                <div className={'ob-awards-block__wrapper'}>
                    { this.awards && this.awards.map((block, index) => {
                        return this.renderAward(block, index);
                    })}
                </div>
            </div>
        );
    }
}

AwardsBlock.propTypes = {
    extraAttributes: PropTypes.object,
};

export default AwardsBlock;